module.exports = __webpack_public_path__ + "static/media/ela.2fe8d00b.svg";